import {AsyncStatusesEnum} from '../../../../../../libs/shared/helpers/src/types/asyncStatuses';
import {AppAction} from '../../../../appActions';
import {CrmPreviewActionsEnum} from './crmPreviewActions';
import {CrmPreviewPanelState} from './crmPreviewState';

export function crmPreviewReducer(state: CrmPreviewPanelState, action: AppAction): CrmPreviewPanelState {
  switch (action.type) {
    case CrmPreviewActionsEnum.FETCH_PREVIEW_DATA: {
      if (state.id !== action.payload.panelId) {
        return state;
      }
      return {
        ...state,
        accounts: undefined,
        cards: undefined,
        status: AsyncStatusesEnum.LOADING,
      };
    }

    case CrmPreviewActionsEnum.FETCH_PREVIEW_DATA_COMPLETED: {
      if (state.id !== action.payload.panelId) {
        return state;
      }
      return {
        ...state,
        accounts: action.payload.accounts,
        cards: action.payload.cards,
        selectedId: action.payload.accounts[0]?.id || action.payload.cards[0]?.id,
        status: AsyncStatusesEnum.LOADED,
      };
    }

    case CrmPreviewActionsEnum.FETCH_PREVIEW_DATA_FAILED: {
      if (state.id !== action.payload.panelId) {
        return state;
      }
      return {
        ...state,
        status: AsyncStatusesEnum.FAILED,
      };
    }

    case CrmPreviewActionsEnum.UPDATE_SELECTED_ID: {
      if (state.id !== action.payload.panelId) {
        return state;
      }
      return {
        ...state,
        selectedId: action.payload.selectedId,
      };
    }

    default: {
      return state;
    }
  }
}
